import { render, staticRenderFns } from "./blankAccount.vue?vue&type=template&id=7ddee566&scoped=true&"
import script from "./blankAccount.vue?vue&type=script&lang=js&"
export * from "./blankAccount.vue?vue&type=script&lang=js&"
import style0 from "./blankAccount.vue?vue&type=style&index=0&id=7ddee566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddee566",
  null
  
)

export default component.exports